<script setup lang="ts">
import { Toasts } from "@/components";
</script>

<template>
  <div
    class="pfreundt-blank-layout"
    data-testid="blank-layout"
    data-application="load-and-go"
  >
    <slot />
  </div>
  <div class="toasts">
    <Toasts />
  </div>
</template>

<style>
@import "@pfreundt-ew/design-system/src/layouts/Blank/Blank.css";

.toasts {
  position: fixed;
  inset-inline: 50%;
  inset-block-end: var(--spacing-12);
  inline-size: max-content;
  transform: translateX(-50%);
}
</style>
